import t from"react";import{mdiPencil as i}from"@mdi/js";import{MdIcon as e}from"./MdIcon.js";const o=({id:o="pencil",title:r="Edit",...m})=>t.createElement(e,{id:o,title:r,path:i,...m});export{o as PencilIcon};
